/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_SubtitleInputs */

const en_profile_subtitle = /** @type {(inputs: Profile_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adjust your preferences`)
};

const ja_profile_subtitle = /** @type {(inputs: Profile_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`設定を調整する`)
};

const fr_profile_subtitle = /** @type {(inputs: Profile_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajustez vos préférences`)
};

const de_profile_subtitle = /** @type {(inputs: Profile_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungen anpassen`)
};

/**
* | output |
* | --- |
* | "Adjust your preferences" |
*
* @param {Profile_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const profile_subtitle = /** @type {((inputs?: Profile_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_subtitle(inputs)
	if (locale === "ja") return ja_profile_subtitle(inputs)
	if (locale === "fr") return fr_profile_subtitle(inputs)
	return de_profile_subtitle(inputs)
});